import { render, staticRenderFns } from "./NewEditFranquiaPage.vue?vue&type=template&id=590fc933"
import script from "./NewEditFranquiaPage.vue?vue&type=script&lang=js"
export * from "./NewEditFranquiaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports